import React from 'react'

import CartSection from 'components/cart/Section/Section'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import TotalPrice from './TotalPrice/TotalPrice'
import Credits from './Credits/Credits'
import BillRow, { BillRowProps } from './BillRow/BillRow'

import s from './Bill.scss'


type BillProps = {
  isFetching?: boolean
  items?: Array<BillRowProps>
  total: number
  credits?: number
  creditValue?: number
  creditBalance?: number
  useCredits?: boolean
  resubscribeMessage?: ReactIntlMessage
}

const PaymentBill: React.FunctionComponent<BillProps> = (props) => {
  const {
    isFetching = false,
    items = [],
    total,
    credits,
    creditValue,
    creditBalance,
    useCredits,
    resubscribeMessage,
  } = props

  return (
    <div className={s.bill}>
      {
        items.map((item, index) => (
          <BillRow key={index} {...item} isFetching={isFetching} />
        ))
      }
      {/* TODO it's better to split this component on 3: bill, balance, resubscribe mess, total price */}
      {
        Boolean(credits) && (
          <Credits {...{ isFetching, total, creditValue, creditBalance, useCredits }} />
        )
      }
      <CartSection>
        {
          Boolean(resubscribeMessage) && (
            <Box mb={16}>
              <Text message={resubscribeMessage} uppercase />
            </Box>
          )
        }
        <TotalPrice {...{ isFetching, total }} />
      </CartSection>
    </div>
  )
}


export default PaymentBill
